import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  input,
  OnChanges,
  OnDestroy,
  Output,
  signal,
  SimpleChanges,
  WritableSignal,
} from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { EV_PLURALS } from '@shared/consts/plurals';
import { CarItem } from '@shared/models/car-item';
import { SelectOption } from '@shared/models/select-option';
import { PluralPipe } from '@shared/pipes/plural.pipe';
import { CarCardComponent } from '@shared/ui-components/car-card/car-card.component';
import { CarRowComponent } from '@shared/ui-components/car-row/car-row.component';
import { SectionLoaderComponent } from '@shared/ui-components/section-loader/section-loader.component';
import { Subject } from 'rxjs';

@Component({
  selector: 'evland-car-list',
  templateUrl: './car-list.component.html',
  styleUrls: [ './car-list.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    PluralPipe,
    ReactiveFormsModule,
    MatIcon,
    SectionLoaderComponent,
    CarRowComponent,
    CarCardComponent,
  ],
})
export class CarListComponent implements OnChanges, OnDestroy {
  columns = input<number>(3);
  cars = input.required<CarItem[]>();
  isLoading = input<boolean>(false);
  isUpdating = input<boolean>(false);
  sortOptions = input<SelectOption[]>([]);
  total = input<number>(0);
  initValue = input<string>();
  hideToolbar = input<boolean>(false);
  @Output() sortChange = new EventEmitter<string>();

  EV_PLURALS = EV_PLURALS;

  sortControl: UntypedFormControl;
  view: WritableSignal<'grid' | 'list'> = signal('grid');

  private readonly destroyed$ = new Subject<void>();

  #fb = inject(UntypedFormBuilder);

  constructor() {
    this.initSort();
  }

  ngOnChanges(changes: SimpleChanges): void {
    const { initValue } = changes;
    const sortOptions = this.sortOptions();

    if (!sortOptions.length || !initValue) return;

    this.sortControl.reset(
      initValue.currentValue || sortOptions[0].value,
      { emitEvent: !initValue.firstChange },
    );
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  setView(view: 'grid' | 'list'): void {
    this.view.set(view);
  }

  private initSort(): void {
    this.sortControl = this.#fb.control(null, Validators.required);

    this.sortControl
      .valueChanges
      .subscribe(value => this.sortChange.emit(value));
  }
}
